const $inject = [];

const formValidationService = function () {
    let service = {
        menuItems: [],
        setMenuItems: setMenuItems
    };


    function setMenuItems(navMenuItems) {
        service.menuItems = navMenuItems;
    }

    return service;
};

formValidationService.$inject = $inject;

export default formValidationService;


// WEBPACK FOOTER //
// ./src/services/formValidationService.js